import React, { useState, useEffect } from 'react';
import Logo from "../../assets/Logo.svg";
import "./header.css"; 

const Header = () => {
    const [Toggle, setToggle] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");

    const handleResize = () => {
        const menuCloseIcon = document.getElementById('menuCloseIcon');
        if (window.innerWidth > 768) {
            menuCloseIcon.style.display = 'none';
        } else {
            menuCloseIcon.style.display = 'block';
        }
    }

    useEffect(() => {
        // Add an event listener to handle window resize when the component mounts
        window.addEventListener('resize', handleResize);

        // Call the function on page load to set the initial state
        handleResize();

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <header className={`header ${Toggle ? 'scroll-header' : ''}`}>
            <nav className="nav container">
                <a href="index.html" className="nav__logo">
                    <img
                        src={Logo}
                        alt=""
                        height="100"
                        width="175"
                        style={{
                            borderRadius: "20%", // Make the image round
                            overflow: "hidden", // Ensure the round shape is maintained
                        }}
                    />
                </a>

                <div className={`nav__menu ${Toggle ? 'show-menu' : ''}`}>
                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <a href="#home" onClick={() => setActiveNav('#home')} className="nav__link">
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#about" onClick={() => setActiveNav("#about")} className="nav__link">
                                <i className="uil uil-user nav__icon"></i> About
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#skills" onClick={() => setActiveNav("#skills")} className="nav__link">
                                <i className="uil uil-file-alt nav__icon"></i> Skills  
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#services" onClick={() => setActiveNav("#services")} className="nav__link">
                                <i className="uil uil-briefcase-alt nav__icon"></i> Services
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#qualification" onClick={() => setActiveNav("#qualification")} className="nav__link">
                                <i className="uil uil-scenery nav__icon"></i> Qualification
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#contact" onClick={() => setActiveNav("#contact")} className="nav__link">
                                <i className="uil uil-message nav__icon"></i> Contact me 
                            </a>
                        </li>
                        </ul>
                    <i
                        id="menuCloseIcon"
                        className="uil uil-times nav__close"
                        onClick={() => setToggle(!Toggle)}
                    ></i>
                </div>

                <div className="nav__toggle" onClick={() => setToggle(!Toggle)}>
                    <i className="uil uil-apps"></i>
                </div>
            </nav>
        </header>
    );
}

export default Header;